import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.sass']
})
export class ResultComponent implements OnInit {
  pmt: number = 0.0;
  tier: number = 0;
  successful: boolean = false;
  error: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ResultComponent>,
      @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      console.log(data);

      if (data.hasOwnProperty('status')) {
        if (data.status.hasOwnProperty('error')) {
          this.error = data.status.error;
        }
      }

      if (data.hasOwnProperty('Error')) {
        this.error = true;
      }
    }

  ngOnInit() {
    if (!this.error) {
      if (this.tier > 0 && this.tier < 4) {
        this.successful = true;
      }
    }

    
  }

}
